const selectors = {
  routineInfo: (state) => state.routineDetails.routineInfo,
  audioUrl: (state) => state.routineDetails.audioUrl,
  media: (state) => state.routineDetails.media,
  pagination: (state) => state.routineDetails.media.pagination,
  filters: (state) => state.routineDetails.media.filters,
  list: (state) => state.routineDetails.media.list,

  dancers: {
    routineDancers: (state) => state.routineDetails.dancers.routineDancers,
    loadingRoutineDancersStatus: (state) =>
      state.routineDetails.dancers.loadingRoutineDancersStatus,
    currentPage: (state) => state.routineDetails.dancers.currentPage,
  },

  performances: {
    routinePerformances: (state) =>
      state.routineDetails.performances.routinePerformances,
    currentPage: (state) => state.routineDetails.performances.currentPage,
    loadingRoutinePerformancesStatus: (state) =>
      state.routineDetails.performances.loadingRoutinePerformancesStatus,
  },

  loadingRoutineInfoStatus: (state) =>
    state.routineDetails.loadingRoutineInfoStatus,
  routineDeletingStatus: (state) => state.routineDetails.routineDeletingStatus,
  loadingRoutineMedia: (state) =>
    state.routineDetails.media.loadingMediaListStatus,
  loadedRoutineDancers: (state) => state.routineDetails.loadedRoutineDancers,
  loadedRoutinePerformances: (state) =>
    state.routineDetails.loadedRoutinePerformances,
  loadedRoutineMedia: (state) => state.routineDetails.loadedRoutineMedia,
};

export { selectors };
